import { FC } from 'react';
import { Spin } from 'antd';
import { Container } from './Loader.styles';

interface LoaderProps {
  /** True (default) covers the viewport with the brand background; false for inline use inside a page. */
  fullscreen?: boolean;
  /** Spin size — 'large' by default. Use 'small' for inline / compact loading states. */
  size?: 'small' | 'default' | 'large';
}

const Loader: FC<LoaderProps> = ({ fullscreen = true, size = 'large' }) => (
  <Container $fullscreen={fullscreen} $compact={size !== 'large'}>
    <Spin size={size} />
  </Container>
);

export default Loader;
